// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2409": "e931dc11cbf2","3180": "55ac633bc921","3583": "2678fc5a43c4","6500": "32a72beb18e6","8272": "ac01f96618b0","8914": "92b34e92d99e","9383": "8c3594366772",}[chunkId] + ".css"
}